import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

import { petrol } from '../../../styles/mui/colors';

// Dachzelt

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.ReactNode}
 */
const IconVehiclesCarTentComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest} fontSize="large" viewBox="0 0 512 512">
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask height="24" id="mask0_3141_193" maskUnits="userSpaceOnUse" width="24" x="0" y="0">
          <path d="M0 1.90735e-06H24V24H0V1.90735e-06Z" fill="white" />
        </mask>
        <g mask="url(#mask0_3141_193)">
          <path
            d="M0.351562 10.6646V17.0864"
            fill="none"
            stroke="#0E3B43"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M3.8047 19.8755H1.75781V10.1724C1.75781 9.39569 2.38739 8.76611 3.16406 8.76611H18.0469C18.5842 8.76611 19.0527 9.1315 19.1835 9.65266L20.2829 14.0319C20.336 14.2436 20.4845 14.4186 20.6847 14.5056L21.6782 14.9372C22.0207 15.0859 22.2422 15.4237 22.2422 15.797V19.8755"
            fill="none"
            stroke="#0E3B43"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M18.0264 21.9849C16.8614 21.9849 15.917 21.0405 15.917 19.8755C15.917 18.7105 16.8614 17.7661 18.0264 17.7661C19.1914 17.7661 20.1357 18.7105 20.1357 19.8755C20.1357 21.0405 19.1914 21.9849 18.0264 21.9849Z"
            fill="none"
            stroke="#0E3B43"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M5.97949 21.9849C4.81451 21.9849 3.87012 21.0405 3.87012 19.8755C3.87012 18.7105 4.81451 17.7661 5.97949 17.7661C7.14448 17.7661 8.08887 18.7105 8.08887 19.8755C8.08887 21.0405 7.14448 21.9849 5.97949 21.9849Z"
            fill="none"
            stroke="#0E3B43"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M13.289 19.8755H8.15918"
            fill="none"
            stroke="#0E3B43"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M15.8701 19.8755H14.9297"
            fill="none"
            stroke="#0E3B43"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M22.2422 18.4692H23.1826C23.4415 18.4692 23.6484 18.6791 23.6484 18.938V19.4067C23.6484 19.6656 23.4415 19.8755 23.1826 19.8755H20.2266"
            fill="none"
            stroke="#0E3B43"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M7.69043 18.4692H16.3623"
            fill="none"
            stroke="#0E3B43"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M3.53906 8.71875V7.50886"
            fill="none"
            stroke="#0E3B43"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M17.3203 3.64886V8.73438"
            fill="none"
            stroke="#0E3B43"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M2.96355 7.50879C2.65526 7.50879 2.37246 7.30455 2.28626 6.99298C2.18271 6.61873 2.40218 6.23135 2.77643 6.1278L17.5487 2.04073C17.9231 1.93732 18.3103 2.15665 18.4139 2.5309C18.5174 2.9052 18.298 3.29252 17.9237 3.39607L3.15143 7.48315C3.08871 7.50049 3.02557 7.50879 2.96355 7.50879Z"
            fill="none"
            stroke="#0E3B43"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M17.3496 5.29736H17.5547C17.8136 5.29736 18.0234 5.50722 18.0234 5.76611V6.42236C18.0234 6.68125 17.8136 6.89111 17.5547 6.89111H17.3481"
            fill="none"
            stroke="#0E3B43"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M6.82031 10.1724H9.35156C9.48098 10.1724 9.58594 10.2773 9.58594 10.4067V13.7349C9.58594 13.8643 9.48098 13.9692 9.35156 13.9692H6.82031C6.69089 13.9692 6.58594 13.8643 6.58594 13.7349V10.4067C6.58594 10.2773 6.69089 10.1724 6.82031 10.1724Z"
            fill="none"
            stroke="#0E3B43"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M11.2266 10.1724H13.7578C13.8872 10.1724 13.9922 10.2773 13.9922 10.4067V13.7349C13.9922 13.8643 13.8872 13.9692 13.7578 13.9692H11.2266C11.0971 13.9692 10.9922 13.8643 10.9922 13.7349V10.4067C10.9922 10.2773 11.0971 10.1724 11.2266 10.1724Z"
            fill="none"
            stroke="#0E3B43"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M15.6328 10.1724H17.6546C17.7614 10.1724 17.8546 10.2446 17.8815 10.3479L18.7443 13.676C18.7828 13.8244 18.6707 13.9692 18.5174 13.9692H15.6328C15.5034 13.9692 15.3984 13.8643 15.3984 13.7349V10.4067C15.3984 10.2773 15.5034 10.1724 15.6328 10.1724Z"
            fill="none"
            stroke="#0E3B43"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M15.375 15.3755H16.3594"
            fill="none"
            stroke="#0E3B43"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M0.375 11.8599H1.73437"
            fill="none"
            stroke="#0E3B43"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M0.375 13.9692H1.73437"
            fill="none"
            stroke="#0E3B43"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M0.375 16.0786H1.73437"
            fill="none"
            stroke="#0E3B43"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
        </g>
      </svg>
    </SvgIcon>
  );
};

IconVehiclesCarTentComponent.displayName = 'IconVehiclesCarTent';
const IconVehiclesCarTent = memo(IconVehiclesCarTentComponent);

export default IconVehiclesCarTent;
